'use strict'
module.exports = {
  NODE_ENV: 'development',
  BASE_URL: 'http://localhost:3010',
  PUBNUB_SUB_KEY: 'sub-c-2b01bab8-5db5-11ec-96e9-32997ff5e1b9',
  PUBNUB_PUB_KEY: 'pub-c-7729d814-77a1-46cd-b957-a30451a7d67e'
}
